module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"back":"Back","post":"Post","input_caption":"Please input caption."}}')
  delete Component.options._Ctor
}
